import React, { Component } from 'react'
import { connect } from 'react-redux'
import { connectResource } from '../utils/resource'
import { compose } from 'redux'

import BasicLayout from './BasicLayout'

class BasicLayoutContainer extends Component {
  state = {
    sidebarHidden: false,
    sidebarHiddenMobile: false,
    minimize: true,
    dropdown: {},
  }

  toggleSidebar = () => {
    this.setState({
      sidebarHidden: !this.state.sidebarHidden,
    })
  }

  toggleSidebarMobile = () => {
    this.setState({
      sidebarHiddenMobile: !this.state.sidebarHiddenMobile,
    })
  }

  toggleMinimizeSidebar = () => {
    this.setState({
      minimize: !this.state.minimize,
    })
  }

  toggleDropdown = (key) => {
    const dropdown = { ...this.state.dropdown }

    dropdown[key] = dropdown[key] ? !dropdown[key] : true

    for (const otherKey in dropdown) {
      if (String(otherKey) !== String(key)) {
        dropdown[otherKey] = false
      }
    }
    this.setState({ dropdown })
  }

  getClass = () => {
    const sidebarHidden = this.state.sidebarHidden ? 'sidebar-hidden' : ''
    const sidebarHiddenMobile = this.state.sidebarHiddenMobile ? 'sidebar-mobile-show' : ''
    const minimizeSidebar = this.state.minimize ? 'brand-minimized sidebar-minimized' : ''
    return `app ${sidebarHidden} ${sidebarHiddenMobile} ${minimizeSidebar}`
  }

  render() {
    return (
      <BasicLayout
        {...this.props}
        {...this.state}
        toggleSidebar={this.toggleSidebar}
        toggleSidebarMobile={this.toggleSidebarMobile}
        toggleMinimizeSidebar={this.toggleMinimizeSidebar}
        toggleDropdown={this.toggleDropdown}
        getClass={this.getClass}
      />
    )
  }
}

export default compose(
  connectResource({ namespace: 'user', endpoint: 'users', prefetch: false }),
  connect(null, (dispatch) => ({ dispatch })),
)(BasicLayoutContainer)
